import * as actionTypes from './actionTypes';
import apiAxios from '../../_services/api/axios';

export const defaultsFetchStart = () => {
    return {
        type: actionTypes.DEFAULTS_FETCH_START
    };
};

export const defaultsFetchSuccess = (countries, currencies, genders) => {
    return {
        type: actionTypes.DEFAULTS_FETCH_SUCCESS,
        countries: countries,
        currencies: currencies,
        genders: genders
    };
};

export const defaultsFetchFail = () => {
    return {
        type: actionTypes.DEFAULTS_FETCH_FAIL
    };
};

const getCountries = () => {
	return apiAxios.get( '/defaults/countries' )
}

const getCurrencies = () => {
	return apiAxios.get( '/defaults/currencies' )
}

const getGenders = () => {
	return apiAxios.get( '/defaults/genders' )
}

export const defaultsFetch = () => {
    return dispatch => {
        dispatch(defaultsFetchStart());
        Promise.all([ getCountries(), getCurrencies(), getGenders() ])
	    .then(([countries, currencies, genders]) =>  {
	    	dispatch( defaultsFetchSuccess( countries.data.list, currencies.data.list, genders.data.list) );
	    })
	    .catch(error => {
            dispatch( {type: actionTypes.VISUALMESSAGE_SET, payload: {scope: "defauts", key: "default", message: "Resource not available, please try it again later.", type: 'error', obj: error} } ); 
            dispatch( defaultsFetchFail( error.response ) );
	    });
    };
};

export const defaultsGet = () => {
    return {
        type: actionTypes.DEFAULTS_GET
    };
};


// WEBPACK FOOTER //
// ./src/_store/actions/defaults.js